import { Span, SpanContext, DefaultSpanData } from './Span';
import { Action, ActionContext, DefaultActionData } from '@ui/utils/ActivityManager/Action';
import { View } from './View';
import { timestamp } from './utils/Time';

export type FixedSpan = Span<DefaultSpanData>;
export type FixedAction = Action<DefaultActionData>;

export type Event = FixedSpan | FixedAction;

export function isSpan(event: Event): event is FixedSpan {
  return event instanceof Span;
}
interface EventCollectorOptions {
  onEventEnd?: (event: Event) => void;
}

export class EventCollector {
  onEventEnd?: (event: Event) => void;
  inProgressSpans: FixedSpan[] = [];

  constructor(options?: EventCollectorOptions) {
    this.onEventEnd = options?.onEventEnd;
  }

  size() {
    return this.inProgressSpans.length;
  }

  startSpan(spanContext: SpanContext<DefaultSpanData>) {
    const span = new Span({
      ...spanContext,
      onSpanEnd: this.#onSpanEnd,
      onSpanRemove: this.#onSpanRemove,
    });
    this.inProgressSpans.push(span);
    return span;
  }

  #onSpanRemove = (span: FixedSpan) => {
    this.inProgressSpans = this.inProgressSpans.filter((s) => s.spanId !== span.spanId);
  };

  #onSpanEnd = (span: FixedSpan) => {
    this.inProgressSpans = this.inProgressSpans.filter((s) => s.spanId !== span.spanId);
    this.onEventEnd?.(span);
  };

  createAction(actionContext: ActionContext<DefaultActionData>) {
    const action = new Action(actionContext);
    this.onEventEnd?.(action);
    return action;
  }

  find(cb: (span: FixedSpan) => boolean) {
    return this.inProgressSpans.find(cb);
  }

  onViewChange(view: View) {
    this.inProgressSpans.forEach((span) => {
      if (!span.view) {
        return;
      }
      if (span.view.viewId !== view.viewId) {
        span.end(timestamp(), 'PAGE_CHANGE');
      }
    });
  }
}
